
import { PDFDocument, rgb } from 'pdf-lib';

import fontkit from '@pdf-lib/fontkit';

import { capitalize } from '../utils.js';

import { fetchUint8Array, drawText, savePDF } from './utils.js';

import bebasNeueRegular from '../fonts/bebas-neue-regular.ttf';

import openSansRegular from '../fonts/open-sans-regular.ttf';

import openSansBold from '../fonts/open-sans-bold.ttf';

import template from './activity-5-poster-1.pdf';

import { posterStyles } from '../stores/activity-5.js';

import horizontalPlaceholderPath from '../images/activity-5-horizontal-placeholder.png';

import squarePlaceholderPath from '../images/activity-5-square-placeholder.png';

const style = posterStyles.find( ( { id } ) => id === 1 );

export async function exportPDF( firstName, lastName ) {

  const headingFontBytes = await fetchUint8Array( bebasNeueRegular );

  const sansFontBytes = await fetchUint8Array( openSansRegular );
  
  const sansBoldFontBytes = await fetchUint8Array( openSansBold );

  const templateBytes = await fetchUint8Array( template );

  const headerImageBytes = await fetch( style.headerImagePath ?? horizontalPlaceholderPath ).then( data => data.arrayBuffer() );

  const sideImage1Bytes = await fetch( style.sideImage1Path ?? squarePlaceholderPath ).then( data => data.arrayBuffer() );

  const sideImage2Bytes = await fetch( style.sideImage2Path ?? squarePlaceholderPath ).then( data => data.arrayBuffer() );

  const doc = await PDFDocument.load( templateBytes );
  
  doc.registerFontkit( fontkit );

  const headingFont = await doc.embedFont( headingFontBytes, { subset: true } );

  const sansFont = await doc.embedFont( sansFontBytes );
  
  const sansBoldFont = await doc.embedFont( sansBoldFontBytes );

  const headerImage = await doc.embedPng( headerImageBytes );

  const sideImage1 = await doc.embedPng( sideImage1Bytes );

  const sideImage2 = await doc.embedPng( sideImage2Bytes );

  const page = doc.getPages()[ 0 ];

  const ratio = page.getWidth() / 1275;

  const scale = value => ratio * value;

  const headerImageScaled = headerImage.scaleToFit( page.getWidth(), page.getHeight() );

  page.drawImage( headerImage, {
    
    x: 0, y: page.getHeight() - headerImageScaled.height - scale( 74 ),
    
    width: page.getWidth(), height: headerImageScaled.height
  
  } );

  page.drawRectangle( {

    x: scale( 93 ), y: page.getHeight() - scale( 495 + 648 ),

    width: scale( 522 ), height: scale( 648 ),
    
    color: rgb( 0.25, 0.22, 0.01 ), opacity: 0.9

  } );

  let x = scale( 145 ), y = scale( 565 ), height = 0;

  ( { y, height } = 

    drawText( {
      
      doc, page, x, y, align: 'top left',
      
      font: headingFont, size: 28, maxWidth: scale( 420 ), color: 0xffffff,
      
      text: ( style.title || 'No title.' ).replace( /\n/g, ' ' ).toUpperCase()
    
    } ) );

  ( { y, height } = 

    drawText( {
      
      doc, page, x, y: y + height + 12, align: 'top left',
      
      font: sansBoldFont, size: 12, maxWidth: scale( 380 ), color: 0xffffff,
      
      text: ( style.subtitle || 'No subtitle.' ).replace( /\n/g, ' ' )
    
    } ) );

  ( { y, height } = 

    drawText( {
      
      doc, page, x, y: y + height + 20, align: 'top left',
      
      font: sansFont, size: 10, maxWidth: scale( 420 ), color: 0xffffff,
      
      text: ( style.paragraph1 || 'No paragraph.' ).replace( /\n/g, ' ' )
    
    } ) );

  ( { y, height } =
    
    drawText( {
    
      doc, page, x, y: scale( 495 + 648 + 45 ), align: 'top left',
      
      font: sansFont, size: 10, maxWidth: scale( 420 ),
      
      text: ( style.paragraph2 || 'No paragraph.' ).replace( /\n/g, ' ' )
    
    } ) );
  
  drawText( {
    
    doc, page, x: scale( 93 ), y: y + height + 36, align: 'top left',
    
    font: sansBoldFont, size: 10,
    
    text: `Poster created by:\n${ capitalize( firstName ) } ${ capitalize( lastName ) } (${ new Date().toLocaleString().split( ',' )[ 0 ] })`
  
  } );

  [
    
    { image: sideImage1, caption: style.sideImage1Caption },
    
    { image: sideImage2, caption: style.sideImage2Caption }
  
  ].forEach( ( { image, caption }, index ) => {

    const start = 480;

    const offset = 250 * index;

    page.drawRectangle( { x: 372, y: page.getHeight() - start - 3 - offset, width: 206, height: 206, color: rgb( 1, 1, 1 ) } );

    page.drawImage( image, { x: 375, y: page.getHeight() - start - offset, width: 200, height: 200 } );

    page.drawRectangle( { x: 375, y: page.getHeight() - start - 30 - offset, width: 165, height: 30, color: rgb( 0, 0, 0 ), opacity: 0.85 } );

    drawText( {
      
      doc, page, x: 385, y: start + 12 + offset, align: 'center left',
      
      font: sansFont, size: 9, maxWidth: 145, color: 0xffffff,
      
      text: ( caption || 'No caption.' ).replace( /\n/g, ' ' )
    
    } );

  } );

  doc.setTitle( 'Activity Five - Poster 1' );
  
  doc.setSubject( 'Lewis Mountain' );
  
  doc.setCreator( 'Shenandoah National Park' );
    
  doc.setAuthor( 'National Park Service' );

  doc.setProducer( 'PDF-LIB (https://github.com/Hopding/pdf-lib)' );
  
  doc.setCreationDate( new Date() );
  
  doc.setModificationDate( new Date() );
  
  savePDF( `Lewis-Mountain-Activity-5-${ capitalize( firstName ) }-${ capitalize( lastName ) }`, doc );
  
}